import { api } from "./client";

export type BanquetEventStatus = "draft" | "open" | "closed";

export interface BanquetEvent {
  event_id: string;
  title: string;
  title_en: string;
  tagline: string;
  /** YYYY-MM-DD(後台 date picker;排序 + 同日唯一檢查) */
  event_date: string;
  /** 顯示字串,由 event_date 後端衍生(ex: 2026年06月24日(三)) */
  date_label: string;
  time_label: string;
  venue: string;
  venue_address: string;
  fee_label: string;
  capacity: number;
  capacity_label: string;
  hero_url: string;
  hero_w: number;
  hero_h: number;
  status: BanquetEventStatus;
  created_at?: string;
  updated_at?: string;
  /** admin 場次列表才有:已訂席位(pending+confirmed) */
  seats?: number;
}

export type BanquetStatus = "pending" | "confirmed" | "waitlist" | "cancelled";

// 會員端「我的預約」(/api/banquet/open 的 my_reservation、重複預約回的 reservation)只回白名單欄位 —
// 後端 banquet_service.PUBLIC_RESERVATION_FIELDS。member_uid 只有後台預約清單會回(後台頁共用這個 type)。
// 後台代報:非會員來賓的 member_uid 是 "";後台手動建的會員 member_uid 以 manual_ 開頭(沒有 LINE,不會收到推播)。
export interface BanquetReservation {
  id: string;
  event_id: string;
  member_uid: string;
  name: string;
  phone: string;
  party_size: number;
  note: string;
  status: BanquetStatus;
  created_at: string;
  updated_at: string;
  // 以下兩個欄位:後台預約清單才有(代報);會員端白名單不回
  /** "admin" = 後台代報(會員自己報名的沒有這個欄位) */
  source?: "admin";
  /** 代報者的後台 email */
  created_by?: string;
}

/** /api/banquet/open 回的場次:多帶即時席位統計 + 我的預約 */
export interface BanquetOpenEvent extends BanquetEvent {
  reserved: number;
  remaining: number;
  my_reservation: BanquetReservation | null;
}

export async function getBanquetOpen() {
  const { data } = await api.get("/api/banquet/open");
  return data as { events: BanquetOpenEvent[] };
}

export async function reserveBanquet(payload: {
  event_id: string;
  name: string;
  phone: string;
  party_size: number;
  note?: string;
}) {
  const { data } = await api.post("/api/banquet/reservations", payload);
  return data as {
    status: string;
    reservation_id?: string;
    waitlist?: boolean;
    reservation?: BanquetReservation;
  };
}
